const UIElementCardTypePolicy = {
  UIElementCard: {
    keyFields: false,
  },
};

export default UIElementCardTypePolicy;
